// TopBar + BackButton — ported from design-canon/project/src/components.jsx → TopBar
import type { ReactNode } from 'react'
import { Icon } from './Icon'

export function TopBar({
  left,
  title,
  right,
  eyebrow,
}: {
  left?: ReactNode
  title?: string
  right?: ReactNode
  eyebrow?: string
}) {
  return (
    <header className="screen-head">
      <div style={{ width: 44 }}>{left}</div>
      <div className="head-title">
        {eyebrow ? <div className="eyebrow">{eyebrow}</div> : null}
        {title ? <div className="h-xs">{title}</div> : null}
      </div>
      <div className="head-right">{right}</div>
    </header>
  )
}

export function BackButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      className="icon-btn"
      onClick={onClick}
      aria-label="Back"
      style={{ background: 'var(--paper)' }}
    >
      <Icon name="back" size={22} />
    </button>
  )
}
